import React, { Component } from 'react'
import { Button, Form, Table, Modal, Input, message, Icon, Switch, Select } from 'antd'
import {
  getWxMiniappPayBind,
  addWxMiniappPayBind,
  reviseWxMiniappPayBind,
  deleteWxMiniappPayBind,
  getWxPayMchOptions,
} from '_src/api/api'

const { confirm } = Modal

@Form.create({ name: 'WxMiniappPayBind' })
class WxMiniappPayBindPage extends Component {
  constructor (props) {
    super(props)
    this.id = ''
    this.param = { pageNum: 0, totalElements: 0 }
    this.state = { loading: true, visible: false, dataList: [], mchOptions: [] }
  }

  componentDidMount () {
    this.loadData()
    getWxPayMchOptions().then(res => {
      this.setState({ mchOptions: res.data || [] })
    }).catch(() => {})
  }

  loadData () {
    this.setState({ loading: true })
    getWxMiniappPayBind({ pageSize: 10, pageNum: this.param.pageNum })
      .then(res => {
        const { content, totalElements } = res.data
        this.param.totalElements = totalElements
        this.setState({
          dataList: (content || []).map((item, index) => ({ ...item, key: item.id, sort: index + 1 })),
          visible: false,
          loading: false,
        })
      })
      .catch(() => this.setState({ loading: false }))
  }

  columns = () => ([
    { title: '排序', align: 'center', dataIndex: 'sort' },
    { title: '小程序AppId', align: 'center', dataIndex: 'appId' },
    { title: '商户号', align: 'center', dataIndex: 'mchId' },
    { title: '名称', align: 'center', dataIndex: 'name' },
    {
      title: '启用',
      align: 'center',
      dataIndex: 'enabled',
      render: item => (item === 1
        ? <Icon type="check-circle" theme="twoTone" style={{ color: 'green', fontSize: 20 }} />
        : <Icon type="close-circle" theme="filled" style={{ color: '#ccc', fontSize: 20 }} />),
    },
    {
      title: '操作',
      align: 'center',
      render: (_, record) => (
        <div>
          <Button icon="form" type="primary" style={{ marginRight: 10 }} onClick={() => this.onEdit(record)}>编辑</Button>
          <Button icon="stop" type="danger" onClick={() => this.handleDisable(record)}>禁用</Button>
        </div>
      ),
    },
  ])

  onEdit (record) {
    this.id = (record && record.id) || ''
    this.setState({ visible: true }, () => {
      const r = record || {}
      this.props.form.setFieldsValue({
        enabled: r.enabled !== 0,
        appId: r.appId || '',
        mchId: r.mchId || '',
        name: r.name || '',
      })
    })
  }

  handleDisable = (record) => {
    const _self = this
    confirm({
      title: '温馨提示',
      content: (<p>确定禁用绑定 <strong style={{ color: 'red' }}>{record.appId}</strong>？</p>),
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk () {
        deleteWxMiniappPayBind(record.id).then(() => _self.loadData())
      },
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (err) return
      const hide = message.loading(this.id ? '修改中' : '添加中', 0)
      const param = { ...values, enabled: values.enabled !== false }
      const req = this.id
        ? reviseWxMiniappPayBind(this.id, param)
        : addWxMiniappPayBind(param)
      req.then(() => {
        hide()
        message.success('保存成功', 1.5)
        this.loadData()
      }).catch(() => {
        hide()
        message.error('保存失败', 1.5)
      })
    })
  }

  render () {
    const { dataList, visible, loading, mchOptions } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <div className="page_content">
        <div className="simple_top">
          <Button type="primary" icon="plus" onClick={() => this.onEdit()}>添加绑定</Button>
        </div>
        <Table
          loading={loading}
          bordered
          columns={this.columns()}
          dataSource={dataList}
          pagination={{
            current: this.param.pageNum + 1,
            total: this.param.totalElements,
            onChange: (page) => { this.param.pageNum = page - 1; this.loadData() },
          }}
        />
        <Modal
          title="小程序支付商户绑定"
          width={600}
          visible={visible}
          onCancel={() => this.setState({ visible: false })}
          footer={false}
          destroyOnClose
        >
          <Form onSubmit={this.onSubmit} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
            <Form.Item label="启用">
              {getFieldDecorator('enabled', { valuePropName: 'checked', initialValue: true })(<Switch />)}
            </Form.Item>
            <Form.Item label="小程序AppId">
              {getFieldDecorator('appId', { rules: [{ required: true, message: '必填' }] })(
                <Input placeholder="wx..." disabled={!!this.id} />
              )}
            </Form.Item>
            <Form.Item label="商户号">
              {getFieldDecorator('mchId', { rules: [{ required: true, message: '必填' }] })(
                <Select placeholder="选择已启用商户" showSearch optionFilterProp="children">
                  {mchOptions.map(o => (
                    <Select.Option key={o.mchId} value={o.mchId}>
                      {o.mchId}{o.name ? `（${o.name}）` : ''}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="名称">
              {getFieldDecorator('name')(<Input placeholder="备注" />)}
            </Form.Item>
            <Form.Item style={{ paddingLeft: 140 }}>
              <Button type="primary" htmlType="submit" icon="save" style={{ width: 248 }}>保存</Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default WxMiniappPayBindPage
